import React from "react";
// Material core components
import IconButton from "@material-ui/core/IconButton";
import Drawer from "@material-ui/core/Drawer";
import CircularProgress from "@material-ui/core/CircularProgress";
// Material core styles
import { withStyles } from "@material-ui/core/styles";
// Dependencies
import MaterialTable from "material-table";
import _ from "lodash";
// Redux
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
// Material ui icons
import { tableIcons } from "../../../../constants/materialTableIcons";
import ClearIcon from "@material-ui/icons/Clear";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import green from "@material-ui/core/colors/green";
// Actions
import { updateWidgetData } from "../../../../redux/actions/dashboardActions";
import { removeMessage } from "../../../../redux/actions/commonActions";
import { Line } from "react-chartjs-2";
import { lineOptions } from "../../../../views/Dashboard/example/VoiceHubWidgets/_commonSharedChartOptions";
import Typography from "@material-ui/core/Typography";

const CheckIcon = () => {
  return <CheckCircleIcon style={{ color: green[600] }} />;
};

const styles = theme => ({
  drawerPaper: {
    zIndex: 1190,
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    },
    [theme.breakpoints.up("md")]: {
      width: "70%"
    },
    [theme.breakpoints.up("lg")]: {
      width: "50%"
    }
  },
  drawer: {}
});

class RightSidebar extends React.Component {
  state = {
    content: undefined,
    data: undefined,
    reloadTableAfterUpdate: false
  };

  componentWillReceiveProps(nextProps, nextContext) {
    // if (nextProps.detailProps === this.props.detailProps) {
    if (_.isEqual(nextProps.detailProps, this.props.detailProps)) {
      if (nextProps.widgetDetails && nextProps.detailProps.contentType === "table_data") {
        this.callAsyncTableFunction(nextProps.widgetDetails);
      } else if (nextProps.widgetDetails && this.props.detailProps.contentType === "graph") {
        this.callAsyncGraphFunction(nextProps.widgetDetails);
      }
    }

    if (nextProps.updatedData && this.state.reloadTableAfterUpdate) {
      this.updateTableDataset(nextProps.updatedData);
      this.setState({ reloadTableAfterUpdate: false });
    }
  }

  updateTableDataset = newData => {
    let oldData = this.state.data;
    for (let i = 0; i < newData.length; i++) {
      newData[i].status = "Reviewed";
      newData[i].tableData.checked = false;
      oldData[newData[i].tableData.id] = newData[i];
    }
    this.setState({ data: oldData });
  };

  callAsyncTableFunction = async data => {
    await this.renderTableData(data);
    let content = await this.getContent();
    this.setState({ content: content });
  };

  callAsyncGraphFunction = async data => {
    await this.renderGraphData(data);
    let content = await this.getContent();
    this.setState({ content: content });
  };

  async renderGraphData(data) {
    this.setState({ data: data });
  }

  async renderTableData(data) {
    const meta = _.get(this.props, "detailProps", "");
    let finalData = [];
    let headers = [];

    if (data.status === "error") {
      this.setState({ data: undefined });
      return;
    }

    for (let i = 0; i < meta.data.data.header.length; i++) {
      headers.push(meta.data.data.header[i].field);
    }

    for (let j = 0; j < data.data.data.length; j++) {
      let obj = {};
      for (let k = 0; k < data.data.data[j].length; k++) {
        if (
          [
            "UNCOMPLETED_REQUESTS_IN_TOTAL_BY_USER_USER_DETAIL",
            "UNCOMPLETED_REQUESTS_FOR_INTENT_FOR_SKILL_DETAILS"
          ].includes(this.props.detailProps.data.Chart) &&
          k === 3
        ) {
          data.data.data[j][k] = JSON.stringify(data.data.data[j][k]);
        } else if (["MISSED_UTTERANCES_LEX"].includes(this.props.detailProps.data.Chart) && k === 6) {
          if (["Reviewed", "Missed"].includes(data.data.data[j][k])) return;
          data.data.data[j][k] = data.data.data[j][k] === true ? "Reviewed" : "Missed";
        }
        obj[headers[k]] = data.data.data[j][k];
      }
      finalData.push(obj);
    }
    this.setState({ data: finalData });
  }

  async getContent() {
    if (this.state.data === undefined) {
      return <div>No data loaded for this item</div>;
    } else {
      if (
        this.props.detailProps.contentType === "table_data" &&
        this.props.detailProps.data.Chart === "MISSED_UTTERANCES_LEX"
      ) {
        return (
          <MaterialTable
            icons={tableIcons}
            title={this.props.detailProps.data.data.title}
            columns={this.props.detailProps.data.data.header}
            data={this.state.data}
            options={{
              selection: true,
              filtering: true,
              showSelectAllCheckbox: false,
              selectionProps: rowData => ({
                disabled: rowData.status === "Reviewed",
                color: "primary"
              })
            }}
            actions={[
              {
                tooltip: "Mark Utterance as Reviewed",
                icon: CheckIcon,
                onClick: (evt, data) => {
                  let queryString = "";
                  for (let i = 0; i < data.length; i++) {
                    let v = i + 1;
                    queryString +=
                      "&skill_name_" +
                      v +
                      "=" +
                      data[i]["skill"] +
                      "&utterance_" +
                      v +
                      "=" +
                      data[i]["utterance"] +
                      "&invocations_" +
                      v +
                      "=" +
                      data[i]["invocations"] +
                      "&users_" +
                      v +
                      "=" +
                      data[i]["dist_users"] +
                      "&first_dt_" +
                      v +
                      "=" +
                      data[i]["first_utt_date"] +
                      "&last_dt_" +
                      v +
                      "=" +
                      data[i]["last_utt_date"];
                  }
                  let payload = "total_selected=" + data.length + queryString;
                  this.props.updateWidgetData(this.props.detailProps.data, data, payload);
                  this.setState({ reloadTableAfterUpdate: true });
                }
              }
            ]}
          />
        );
      } else if (this.props.detailProps.contentType === "table_data") {
        return (
          <MaterialTable
            icons={tableIcons}
            title={this.props.detailProps.data.data.title}
            columns={this.props.detailProps.data.data.header}
            data={this.state.data}
          />
        );
      } else if (
        this.props.detailProps.contentType === "graph" &&
        this.props.detailProps.data.Chart === "NUMBER_OF_UNIQUE_SESSIONS_BY_USER_DETAILS"
      ) {
        return (
          <div style={{ padding: "10px" }}>
            <Typography variant="h6" component="h3" style={{ paddingLeft: "10px", paddingBottom: "10px" }}>
              {this.props.detailProps.data.data.title}
            </Typography>
            <Line
              id={this.props.detailProps.data.Chart}
              data={{
                labels: this.state.data.chart_data.labels,
                datasets: this.state.data.chart_data.data_dict.Items
              }}
              options={_.extend({}, lineOptions, { legend: { display: true } })}
            />
          </div>
        );
      }
    }
  }

  closeRightSidebar = () => {
    this.setState(prevState => ({
      ...prevState,
      content: undefined
    }));
    this.props.toggleRightSidebar();
  };

  render() {
    const { classes, rightSidebarIsOpen, widgetDetails, message, removeMessage } = this.props;
    return (
      <React.Fragment>
        <Drawer
          classes={{ paper: classes.drawerPaper }}
          anchor="right"
          open={rightSidebarIsOpen}
          onClose={this.closeRightSidebar}
        >
          <div>
            <IconButton color="primary" onClick={this.closeRightSidebar}>
              <ClearIcon />
            </IconButton>
          </div>
          {widgetDetails !== undefined && this.state.content ? (
            <div>{this.state.content}</div>
          ) : (
            <div
              style={{
                transform: "translate(-50%, -50%)",
                position: "absolute",
                top: "10%",
                left: "50%"
              }}
            >
              <CircularProgress />
            </div>
          )}
        </Drawer>
      </React.Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        updateWidgetData,
        removeMessage
      },
      dispatch
    ),
    dispatch
  };
}

function mapStateToProps(state, ownProps) {
  return {
    widgetDetails: state.dashboard[_.get(ownProps, "detailProps.data.Chart", "")],
    message: state.common.message,
    updatedData: _.get(state, "dashboard.updatedMissingUtterances.data", undefined)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(RightSidebar));
